// extracted by mini-css-extract-plugin
export default {"container":"modal_container__mx-db pt-10 pb-15","closeButton":"modal_closeButton__DsCEZ","title":"modal_title__+K4Dm text_type_main-large"};